import React, { Component } from 'react';
import { Guardian } from '@xaamin/guardian';
import { Dropdown, ButtonGroup } from 'react-bootstrap';
import LoadingButton from '../../../../../facturotopia/LoadingButton';

import { connect } from 'shalala';
import { useStore } from '../../../../../store';

class TimbradoMasivoListItemActions extends Component {
  handleOnDownloadActionClick = async (original = undefined) => {
    const { selectedRowKeys } = this.props;

    await this.props.download(selectedRowKeys, original);
  };

  handleOnDownloadZip = async () => {
    const { selectedRowKeys } = this.props;

    await this.props.downloadCfdis(selectedRowKeys);
  };

  render() {
    const { alignRight, selectedRowKeys } = this.props;
    const { actionBusy: busy } = this.props;

    return (
      <>
        <Dropdown
          as={ButtonGroup}
          alignRight={alignRight}
        >
          {selectedRowKeys.length === 1 && Guardian.allows('facturacion.masiva.descargar.excel.procesado') && (
            <LoadingButton
              variant="secondary"
              loading={busy}
              onClick={this.handleOnDownloadActionClick.bind(this, undefined)}
            >
              {busy === true ? 'Descargando' : 'Descargar'}
            </LoadingButton>
          )}

          <Dropdown.Toggle
            split
            variant="secondary"
            id="dropdown-split-basic"
          />

          <Dropdown.Menu>
            {Guardian.allows('facturacion.masiva.descargar.archivo.original') && (
              <Dropdown.Item
                as="div"
                onClick={this.handleOnDownloadActionClick.bind(this, 1)}
              >
                Descargar original
              </Dropdown.Item>
            )}

            {Guardian.allows('facturacion.masiva.descarga.masiva') && (
              <Dropdown.Item
                as="div"
                onClick={this.handleOnDownloadZip.bind(this)}
              >
                Descargar zip
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
          {/* <Dropdown.Menu>
            <Dropdown.Item as="div" onClick={ this.handleOnDownloadActionClick.bind(this, 'zip') }>Cancelar procesamiento</Dropdown.Item>
          </Dropdown.Menu> */}
        </Dropdown>
      </>
    );
  }
}

const mapState = (store) => {
  return {
    actionBusy: store.modulo.timbrado_masivo.archivos.actionBusy,
  };
};

const mapActions = (actions, containers) => {
  return {
    download: actions.modulo.timbrado_masivo.archivos.download,
    downloadCfdis: actions.modulo.timbrado_masivo.archivos.downloadCfdis,
  };
};

export default connect(useStore, mapState, mapActions)(TimbradoMasivoListItemActions);
